import * as Parse from 'parse';
import {useEffect, useRef, useCallback} from 'react';
import {formatVersion} from './versionFormatter';
import {fetchVersionSuccess} from '../slices/version';
import {useDispatch} from 'react-redux';

const useLiveVersion = () => {
  const dispatch = useDispatch();
  const subscriptionRef = useRef<Parse.LiveQuerySubscription | null>(null);

  const subscribe = useCallback(async () => {
    const query = new Parse.Query('Version');
    query.equalTo('platform', 'admin');
    subscriptionRef.current = await query.subscribe();
    subscriptionRef.current.on('update', (data: Parse.Object) => {
      const normalizedData = formatVersion(data);
      dispatch(fetchVersionSuccess(normalizedData));
    });
  }, [dispatch]);

  useEffect(() => {
    subscribe();

    return () => {
      subscriptionRef.current?.unsubscribe();
    };
  }, [subscribe]);
};

export default useLiveVersion;
